import { SP } from 'types/pantheon/PantheonSocket';
import { SocketEmitOptions, useSocketEmit } from './useSocketEmit';

export const useSP = (options: SocketEmitOptions = { noSuccess: true, noError: false }): SP.Emitter => {
  const [emit] = useSocketEmit('pantheon.sp', options);
  const spEmit = <TResponse extends Array<unknown>, TParameters = string[]>(query: SP.Request<TParameters>, callback?: (response: SP.Response<TResponse> | undefined) => void) =>
    emit<SP.Request<TParameters>, SP.Response<TResponse>>(query, callback);
  return spEmit;
};
